import { defineMessages } from 'react-intl';

export default defineMessages({
    authorizedUserInfoId: {
        id: 'tdic.manageuser.pages.manage-user.Authorized User Info',
        defaultMessage: 'TDIC allows policyholders to give access to someone they trust. An Authorized User is able to view policy and billing details, and make one-time credit card payments. Restricted areas are {not} available to the Authorized User, such as claims, risk management, and requests for coverage changes or payment plan changes.'
    },
    authorizedUserCheckBoxMessage: {
        id: 'tdic.manageuser.pages.manage-user.By checking the box below, I agree to the Terms Of Use including the Authorized User section.I understand that it is my responsibility to remove my Authorized User when I want to terminate their access to my TDIC account.',
        defaultMessage: 'By checking the box below, I agree to the {link} including the Authorized User section.I understand that it is my responsibility to remove my Authorized User when I want to terminate their access to my TDIC account.'
    },
    createOfficeStaff: {
        id: 'tdic.manageuser.pages.manage-user.Add Authorized User',
        defaultMessage: 'Add Authorized User'
    },
    authorizedUserHeader: {
        id: 'tdic.manageuser.pages.manage-user.Manage Authorized User',
        defaultMessage: 'Manage Authorized User'
    },
    firstName: {
        id: 'tdic.manageuser.pages.manage-user.First Name',
        defaultMessage: 'First Name'
    },
    lastName: {
        id: 'tdic.manageuser.pages.manage-user.Last Name',
        defaultMessage: 'Last Name'
    },
    emailId: {
        id: 'tdic.manageuser.pages.manage-user.Email Id',
        defaultMessage: 'Email Id'
    },
    phoneNumber: {
        id: 'tdic.manageuser.pages.manage-user.Phone Number',
        defaultMessage: 'Phone Number'
    },
    createButton: {
        id: 'tdic.manageuser.pages.manage-user.Add',
        defaultMessage: 'Add'
    },
    deActivateButton: {
        id: 'tdic.manageuser.pages.manage-user.Remove',
        defaultMessage: 'Remove'
    },
    prefix: {
        id: 'tdic.manageuser.pages.manage-user.Prefix',
        defaultMessage: 'Prefix'
    },
    none: {
        id: 'tdic.manageuser.pages.manage-user.None',
        defaultMessage: 'None'
    },
    success: {
        id: 'tdic.manageuser.pages.manage-user.Authorized user addded successfully',
        defaultMessage: 'Authorized user addded successfully'
    },
    error: {
        id: 'tdic.manageuser.pages.manage-user.Account already exists.',
        defaultMessage: 'Account already exists.'
    },
    authorizedUserTnc: {
        id: 'tdic.manageuser.pages.manage-user.By checking the box, I agree to the including the Authorized User section.I understand that it is my responsibility to remove my Authorized User when I want to terminate their access to my TDIC account.',
        defaultMessage: 'By checking the box, I agree to the {link} including the Authorized User section. I understand that it is my responsibility to remove my Authorized User when I want to terminate their access to my TDIC account.'
    },
    removeUser: {
        id: 'tdic.manageuser.pages.manage-user.Are you sure you want to remove this Authorized User ?',
        defaultMessage: 'Are you sure you want to remove this Authorized User ?'
    },
    ok: {
        id: 'tdic.manageuser.pages.manage-user.OK',
        defaultMessage: 'OK'
    },
    cancel: {
        id: 'tdic.manageuser.pages.manage-user.Cancel',
        defaultMessage: 'Cancel'
    },
    remove: {
        id: 'tdic.manageuser.pages.manage-user.Authorized user is removed successfully',
        defaultMessage: 'Authorized user is removed successfully'
    },
    dateCreated: {
        id: 'tdic.manageuser.pages.manage-user.Date created',
        defaultMessage: 'Date Created'
    },
    noAccount: {
        id: 'tdic.manageuser.pages.manage-user.Account not found.',
        defaultMessage: 'Account not found.'
    },
    unableToDeactivate: {
        id: 'tdic.manageuser.pages.manage-user.Deactivate User Request failed',
        defaultMessage: 'Deactivate User Request failed'
    },
    requestFailed: {
        id: 'tdic.manageuser.pages.manage-user.Sorry your request could not be processed at this time',
        defaultMessage: 'Sorry your request could not be processed at this time'
    },
    emailIdPlaceholder: {
        id: 'tdic.manageuser.pages.manage-user.Email ID',
        defaultMessage: 'Email ID'
    },
    existingUserFound: {
        id: 'tdic.manageuser.pages.manage-user.This user already exists.',
        defaultMessage: 'This user already exists.'
    },
    authorisedUserFailed: {
        id: 'tdic.manageuser.pages.manage-user.ERROR',
        defaultMessage: 'ERROR'
    },
    authorisedUserFailedMsg: {
        id: 'tdic.manageuser.pages.manage-user.An error occurred while processing the information. Please try again later.',
        defaultMessage: 'An error occurred while processing the information. Please try again later.'
    }
});
